<template>
	<router-link :to="link" class="creator">
		<img v-if="rowData.creator.avatar" :src="`/images/avatar/${rowData.creator.id}`"
		     class="avatar avatar--small"
		     :title="rowData.creator.name" :alt="`${rowData.creator.name}'s avatar`"
		     :key="rowData.id"
			 width="32" height="32" />
		<img v-else src="//placehold.it/32x32" class="avatar avatar--small" width="32" height="32" />
		<span>{{ rowData.heading }}</span>
	</router-link>
</template>

<script>
	export default {
		name: 'ColumnIntelligence',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
			link() {
				if(this.rowData.status === 2) {
					return { name: 'view-intelligence', params: { intelligence_id: this.rowData.id }}
				} else {
					return { name: 'intelligence-preview', params: { intelligence_id: this.rowData.id }}
				}
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss">
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";

	.creator {
		@include display-flex;
		@include align-items(center);
	}

	.avatar {
		margin-right: 1rem;
		@include flex(0, 0);
	}
</style>
